import React from 'react';
import { List, ListItemButton } from '@mui/material';
import { ThemeContext } from 'src/store/ContextStore';
import { CONSTANTS as Q_CONSTANTS } from 'src/components/questionnaire/Constants';
import { CONSTANTS, PEDIGREE } from 'src/components/Constants';

const GenderMenu = ({
  node,
  memberRecords,
  setMemberRecords,
  handleClose,
  setPedigreeState,
  setError,
  handleDetailsChange
}) => {
  const { theme } = React.useContext(ThemeContext);
  const data = node;

  const gender = data.genderIdentity ?? data.gender;

  const onChange = (value) => {
    const data = node;

    const idx = memberRecords.findIndex((person) => data.pid === person.pid);

    // const relationValid = checkRelationValid(
    //   CONSTANTS.genderMappings[value],
    //   memberRecords,
    //   data
    // );

    // if (!relationValid.status) {
    //   setError(relationValid.message);
    //   return;
    // }

    memberRecords[idx] = {
      ...memberRecords[idx],
      genderIdentity: value,
      gender: CONSTANTS.genderMappings[value]
    };

    // handleDetailsChange([memberRecords[idx]]);

    setMemberRecords([...memberRecords]);

    setPedigreeState((prev) => ({
      ...prev,
      save: PEDIGREE.saveStatus.IN_PROGRESS
    }));

    handleClose();
  };

  return (
    <List>
      {Q_CONSTANTS.genderIdentityOptions.map((option, idx) => {
        return (
          <ListItemButton
            key={idx}
            style={{
              backgroundColor:
                option.value.toLowerCase() === gender.toLowerCase()
                  ? '#e5f6fd'
                  : undefined
            }}
            onClick={() => onChange(option.value)}
          >
            {' '}
            {option.value}{' '}
          </ListItemButton>
        );
      })}
    </List>
  );
};

export default GenderMenu;
